import Cookies from 'universal-cookie'

import {
  IGetUserInfoSuccessResponseBody,
  UserActionTypes,
  IConnectExternalChannel,
  IOpenSsoAdminPortal,
  ISetLastViewedAlert,
  ICreateCustomerPortalSessionPayload,
  ILogoutPayload,
  ISetLastUsedWorkspaceSuccessPayload,
  ISetLastUsedAccountSuccessPayload,
  IUpdateProfilePayload,
  IUpdateProfileSuccessPayload,
  IUpdateProfileFailurePayload,
  IChangeAvatarPayload,
  IChangeAvatarSuccessPayload,
} from './types'

export const logout = (payload: ILogoutPayload) => ({
  type: UserActionTypes.LOGOUT,
  payload
})

export const logoutFailure = () => ({
  type: UserActionTypes.LOGOUT_FAILURE,
})

export const logoutSuccess = () => ({
  type: UserActionTypes.LOGOUT_SUCCESS,
})

export const getUserInfo = () => ({
  type: UserActionTypes.GET_INFO,
})

export const getUserInfoSuccess = (payload: IGetUserInfoSuccessResponseBody) => ({
  type: UserActionTypes.GET_INFO_SUCCESS,
  payload,
})

export const getUserInfoFailure = () => ({
  type: UserActionTypes.GET_INFO_FAILURE,
})

export const updateProfile = (payload: IUpdateProfilePayload) => ({
  type: UserActionTypes.UPDATE_PROFILE,
  payload,
})

export const updateProfileSuccess = (payload: IUpdateProfileSuccessPayload) => ({
  type: UserActionTypes.UPDATE_PROFILE_SUCCESS,
  payload,
})

export const updateProfileFailure = (payload: IUpdateProfileFailurePayload) => ({
  type: UserActionTypes.UPDATE_PROFILE_FAILURE,
  payload
})

export const connectExternalChannel = (payload: IConnectExternalChannel) => ({
  type: UserActionTypes.CONNECT_EXTERNAL_CHANNEL,
  payload
})

export const createCustomerPortalSession = (payload: ICreateCustomerPortalSessionPayload) => ({
  type: UserActionTypes.CREATE_CUSTOMER_PORTAL_SESSION,
  payload,
})

export const createCustomerPortalSessionFailure = () => ({
  type: UserActionTypes.CREATE_CUSTOMER_PORTAL_SESSION_FAILURE,
})

export const openSsoAdminPortal = (payload: IOpenSsoAdminPortal) => ({
  type: UserActionTypes.OPEN_SSO_ADMIN_PORTAL,
  payload
})

export const setLastViewedAlert = (payload: ISetLastViewedAlert) => ({
  type: UserActionTypes.SET_LAST_VIEWED_ALERT,
  payload
})

export const setLastUsedAccountSuccess = (payload: ISetLastUsedAccountSuccessPayload) => ({
  type: UserActionTypes.SET_LAST_USED_ACCOUNT_SUCCESS,
  payload
})

export const setLastUsedWorkspaceSuccess = (payload: ISetLastUsedWorkspaceSuccessPayload) => ({
  type: UserActionTypes.SET_LAST_USED_WORKSPACE_SUCCESS,
  payload
})

export const resetShouldSeeNewsletterPopupSuccess = () => ({
  type: UserActionTypes.RESET_SHOULD_SEE_NEWSLETTER_POPUP_SUCCESS
})

export const setUseLightTheme = () => {
  const cookies = new Cookies()
  cookies.set('useLightTheme', 'true', { path: '/' })

  return { type: UserActionTypes.SET_USE_LIGHT_THEME }
}

export const resetUseLightTheme = () => {
  const cookies = new Cookies()
  cookies.set('useLightTheme', 'false', { path: '/' })

  return { type: UserActionTypes.RESET_USE_LIGHT_THEME }
}

export const setUploadingAvatar = () => ({
  type: UserActionTypes.SET_UPLOADING_AVATAR,
})

export const changeAvatar = (payload: IChangeAvatarPayload) => ({
  type: UserActionTypes.CHANGE_AVATAR,
  payload,
})

export const changeAvatarSuccess = (payload: IChangeAvatarSuccessPayload) => ({
  type: UserActionTypes.CHANGE_AVATAR_SUCCESS,
  payload,
})

export const changeAvatarFailure = () => ({
  type: UserActionTypes.CHANGE_AVATAR_FAILURE,
})
